import { ActionIcon, Group } from '@mantine/core';
import { IconCaretDownFilled, IconCaretUpFilled } from '@tabler/icons-react';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface ToggleGroupProps {
  title: ReactNode;
  label?: string;
  opened: boolean;
  toggle: () => void;
}

export function ToggleGroup({ title, label, toggle, opened }: ToggleGroupProps) {
  const { t } = useTranslation();
  const accessibleTitle = label ?? (typeof title === 'string' ? title : '');

  return (
    <Group>
      {title}
      <ActionIcon
        size="sm"
        variant="filled"
        aria-label={t('annualReport.toggleGroup', { title: accessibleTitle })}
        aria-expanded={opened}
        onClick={toggle}
      >
        {opened ? (
          <IconCaretUpFilled
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        ) : (
          <IconCaretDownFilled
            style={{ width: '70%', height: '70%' }}
            stroke={1.5}
          />
        )}
      </ActionIcon>
    </Group>
  );
}
